import React from 'react';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Container, Grid } from '@material-ui/core';

function SupportPage() {
  const faqs = [
    {
      question: 'Como posso redefinir minha senha?',
      answer:
        "Clique em 'Esqueceu a senha?' na página de login e siga as instruções.",
    },
    {
      question: 'Como reenvio um canhoto rejeitado?',
      answer:
        "No menu lateral acesse 'Pendências', depois clique em 'Reenviar canhoto'.",
    },
    {
      question: 'Como envio uma nota fiscal?',
      answer:
        "Navegue até 'Ordens de Pagamento', depois clique em 'Enviar nota fiscal'.",
    },
    {
      question: 'Como excluo a minha conta?',
      answer: (
        <>
          <a href="fretapp://main/Configurações" style={{ color: 'black' }}><strong>Clique aqui</strong></a>&nbsp;
          para você ser redirecionado para a tela do app, caso esteja lendo isso no seu computador siga os seguintes passos, ou se preferir envie um email para <i> suporte@fretapp.com </i> solicitando exclusão de sua conta.
          <br />
          <br />
          1. No menu lateral do seu aplicativo Fretapp, clique em Configurações
          <br />
          2. Em seguida, selecione 'Excluir conta'.
          <br />
          3. Siga as instruções fornecidas para confirmar a exclusão da sua
          conta.
          <br />
          <br />
          Lembre-se de que uma vez excluída, todas as informações associadas à
          sua conta serão permanentemente removidas.
        </>
      ),
    },
  ];

  return (
    <Container component="main" maxWidth="md">
      <Box mt={4} mb={4}>
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <img
            src="//img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=h:75,cg:true,m/qt=q:95"
            srcSet="//img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:303,h:75,cg:true,m/cr=w:303,h:75/qt=q:95, //img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:607,h:150,cg:true,m/cr=w:607,h:150/qt=q:95 2x, //img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:910,h:225,cg:true,m/cr=w:910,h:225/qt=q:95 3x"
            alt="Fretapp - Entregando Soluções"
          />
        </Grid>
        <Box>
          <Typography textAlign="center" fontFamily={'Raleway'} variant="h5">
            Central de Ajuda
          </Typography>

          <Typography fontFamily={'Raleway'} variant="h6">
            Perguntas frequentes:
          </Typography>
        </Box>

        <Box mt={2}>
          {faqs.map((faq, index) => (
            <Accordion key={index}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontFamily={'Raleway'}>{faq.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography fontFamily={'Raleway'}>{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

        <Box mt={5}>
          <Typography fontFamily={'Raleway'}>
            Não consegue achar a resposta?
          </Typography>
          <Typography fontFamily={'Raleway'} display={'flex'}>
            Entre em contato com nosso time de suporte através do email:&nbsp;
            <strong> suporte@fretapp.com</strong>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}

export default SupportPage;
